<template>
  <div class="body">
    <div class="body-item">
      <div class="body-item-main">
        <div class="visit2" v-loading="!!chart_loading['visit1']">
          <div class="visit-title">用量同环比</div>
          <div class="visit-chart2" ref="visit1"></div>
        </div>
<!--        <div class="visit2" v-loading="!!chart_loading['visit2']">-->
<!--          <div class="visit-title">催缴统计（线上）</div>-->
<!--          <div class="visit-chart2" ref="visit1"></div>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import MeterHttp from "../../../common/MeterHttp";

export default {
  name: "MeterNoteAnalysis",
  inject:['mainObj','componentId','setComponentId'],
  props:{
    master_id:{
      type:String|Number,
      default(){
        return''
      }
    },
  },
  data(){
    return{
      list:[],
      chart_list:{},
      chart_loading:{
        visit1:true,
        visit2:true,
      },
    }
  },
  mounted() {
    const that=this;
    that.chart_list={}
    window.onresize=function () {
      let chart_list_ids=Object.keys(that.chart_list)
      chart_list_ids.map(ret=>{
        that.chart_list[ret].resize();
      });
    }
    that.reData();
  },
  methods:{
    reData(){
      const that = this;
      that.chart_loading.visit1=true;
      that.chart_loading.visit2=false;
      that.getData(list=>{
        that.getChart('visit1',visitOption1([
          {
            col: "old_number",
            name: "去年",
            type:"bar",
          },
          {
            col: "now_number",
            name: "今年",
            type:"bar",
          },
        ],list))
        that.chart_loading.visit1=false;
      })
    },
    getData(callback){
      const that = this;
      let where = {
        project_id:that.mainObj.project_id,
        master_id:that.master_id
      }
      MeterHttp.post("MeterNote/getMeterNoteHistory?user_type="+(that.$route.query.type||0),where, res => {
        if (res.code) {
          if(that.list.length){
            res.data.map((re,index)=>{
              that.list[index]={
                ...that.list[index],
                ...re
              }
            })
          }else {
            that.list=res.data
          }
          typeof callback ==="function"&&callback(that.list)
        }
      })
    },
    getChart(id,option) {
      const that=this;
      let _chart={}
      if(that.chart_list[id]){
        _chart=that.chart_list[id];
        // _chart = echarts.getInstanceByDom(that.$refs[id]);
        _chart.setOption(option);
        that.chart_list[id]=_chart
      }else {
        const _chart = echarts.init(that.$refs[id]);
        _chart.setOption(option);
        that.chart_list[id]=_chart
      }
      return _chart;
    }
  },
  unmounted() {
    this.chart_list={}
  }
}
function visitOption1(groupName=[],list) {
  let cateName=list.map(ret=>ret.ym);
  let cateData=[];
  let cols=[];

  groupName.forEach((ret,index)=>{
    cols.push(ret)
    cateData[index]=list.map(ret2=>ret2[ret.col])
  })
  let d={
    "cateName":cateName,
    "cateData":cateData,
    "groupName":groupName.map(ret=>ret.name)
  }
  const colors = [
    '#0173e7',
    '#1aad3d',
    '#e88b20',
    '#f65555',
    '#38bcbe'
  ];

  let series=[];
  groupName.forEach((ret,index)=>{
    series[index]={
      name: ret.name,
      type: ret.type,
      yAxisIndex: ret.type==='bar'?0:1,
      data: d.cateData[index],
      color:colors[index],
      label: {
        show: true,
        position: 'top'
      },
    }
  })


  return {
    grid: {
      x: '5%',
      width: '90%',
      // y: '12%',
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      }
    },
    toolbox: {
      feature: {
        saveAsImage: { show: true }
      }
    },
    legend: {
      data: d.groupName
    },
    xAxis: [
      {
        type: 'category',
        data: d.cateName,
        axisPointer: {
          type: 'shadow'
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        name: '用量',
      },
      {
        type: 'value',
        name: '率（%）',
        splitLine:{
          show:false
        }
      }
    ],
    series: series
  };
}
</script>

<style lang="scss" scoped>
.body{
  display: flex;
  flex-direction: column;
  background-color: aliceblue;
  .body-item{
    .body-item-header{
      height: 50px;
      line-height: 50px;
      padding-left: 20px;
    }
    .body-item-main{
      display: flex;
      flex-wrap: wrap;
    }
  }
}

.visit1{
  width: calc( 50% - 30px );
  height: calc(448px - 30px);
  margin: 5px;
  padding: 5px;
  background-color: white;
  border-radius: 5px;
  position: relative;

  .visit-chart1{
    width: calc( 100% - 30px );
    height: calc(448px - 80px);
  }
  .visit-chart3{
    width: 400px;
    height: 400px;
  }
  .visit-title{
    padding-left: 10px;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    font-weight: bold;
  }
  .visit-header{
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 999;
    .m-2{
      width: 100px;
    }
  }
}


.visit2{
  width: calc( 100% - 10px );
  //height: calc(448px - 30px);
  margin: 5px;
  padding: 5px;
  background-color: white;
  border-radius: 5px;
  position: relative;

  .visit-title{
    padding-left: 10px;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    font-weight: bold;
  }

  .visit-chart2{
    width: calc( 100% - 10px );
    height: calc(448px - 30px);
  }
  .visit-header{
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 999;
    .m-2{
      width: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_note/components/MeterNoteAnalysis.vue